/* Globals */
import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

/* Environment */

import { StorageService } from './storage.service';
import { TOKEN_URL } from '../constants/url.constants';
import { UsersModel } from '../models/user.model';
import { TOKEN, USER, NOW } from '../constants/storage.constants';
import { environment } from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class GuardService {

  public token: string = '';
  public isAuth: boolean = false;
  public user: UsersModel = new UsersModel();

  //private BASE_URL: String = environment.baseURL;

  constructor(
    private http: HttpClient,
    private router: Router,
    private storageService: StorageService
  ) { }

  canActivate() {
    if (!localStorage.getItem(TOKEN)) {
      this.router.navigate(['/']);
    }

    let now: number = Date.now();
    let localNow: any = parseInt(localStorage.getItem(NOW));

    if (now - localNow > 3600000){
      this.storageService.removeLocalStorage([ TOKEN, USER, NOW]);
    }

    const httpOptions = new HttpHeaders({ 'Authorization': 'Bearer ' + localStorage.getItem('token') });

    return this.http.get(`${ environment.baseURL }${ TOKEN_URL }`, { headers: httpOptions })
      .toPromise()
      .then((data) => {
        this.isAuth = true;
        this.user = JSON.parse(localStorage.getItem(USER));
        this.token = localStorage.getItem(TOKEN);

        return true;
      })
      .catch((err) => {
        console.error(err);
        this.router.navigate(['/']);
      });
  }

}
